import React, { useState, useCallback } from 'react';
import { Modal, Group, Button, Alert, Space } from '@mantine/core';
import { DatePicker } from '@mantine/dates';

interface IDateModalProps { 
    visible: boolean;
    onClose: () => void;
    onSave: (date: Date) => void;
}

export default function DateModal(props: IDateModalProps) {
    const [date, setDate] = useState<Date>(new Date());
    const [errorMessage, setErrorMessage] = useState<string>("");

    const clear = useCallback(() => {
        setDate(new Date());
        setErrorMessage("");
    }, [setDate, setErrorMessage]);

    return (
        <Modal opened={props.visible} onClose={props.onClose} title="Date">
            <DatePicker value={date} placeholder="Date" my={10}
              onChange={(date) => { setDate(date || new Date()); }} 
            />

            <Group position="apart">
                <Button onClick={() => {
                    clear();
                    props.onSave(date);
                }}>Save</Button>

                <Button sx={(theme) => ({ 
                    backgroundColor: theme.colors.gray[4], color: "black", "&:hover": { color: "black", backgroundColor: theme.colors.gray[5] } })} 
                    onClick={() => { clear(); props.onClose(); }}
                >Cancel</Button>
            </Group>

            <Space h="md" />
            {errorMessage && <Alert color="red" title="Error">{errorMessage}</Alert>}
        </Modal>
    );
}